/**
 * Vista: Detalle/Nueva Liberación de Tractor
 * Formato: AMX-PR-FR-03
 */

import produccionService from '../services/produccion.service.js';
import tractorService from '../services/tractor.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  data: {
    liberacion: null,
    tractor: null,
    verificacion: null,
    responsablesLinea: [],   // Responsables de línea (producción)
    responsablesArea: [],    // Responsables de área (producción)
    isNew: false
  },

  async render(params) {
    // Es nuevo si no hay id o si el id es 'nueva'
    this.data.isNew = !params.id || params.id === 'nueva';

    return `
      <div class="card">
        <div id="cardHeader" class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Liberación de Tractor' : 'Liberación de Tractor'}</h2>
          <div style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/produccion/liberaciones')">
              Volver a Lista
            </button>
          </div>
        </div>

        <div id="liberacionContent">
          <div style="text-align: center; padding: 2rem;">
            Cargando...
          </div>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    window.liberacionDetalleView = this;
    this._injectStyles();

    if (this.data.isNew) {
      await this.cargarResponsables();
      this.renderFormularioNuevo();
    } else {
      await this.cargarLiberacion(params.id);
    }
  },

  // Mismas utilidades responsive que OrdenTrabajoDetalle para grillas de formulario
  _injectStyles() {
    if (document.getElementById('liberacion-detalle-styles')) return;
    const style = document.createElement('style');
    style.id = 'liberacion-detalle-styles';
    style.textContent = `
      .lib-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; flex-wrap: wrap; gap: 0; }
      .lib-tab { flex: 1; min-width: 100px; padding: 0.6rem 0.75rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .lib-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
      .lib-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      .lib-tab-panel { margin-bottom: 0.5rem; }
      @media (max-width: 640px) {
        .lib-grid-2col { grid-template-columns: 1fr !important; }
        .lib-grid-3col { grid-template-columns: 1fr !important; }
        .lib-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.25rem; padding: 0.25rem 0; }
        .lib-tab { padding: 0.45rem 0.4rem; font-size: 0.72rem; min-width: 0; }
      }
    `;
    document.head.appendChild(style);
  },

  // Titulo de seccion alineado a Nueva Orden de Trabajo (primary + linea)
  _libSectionTitle(title) {
    return `<h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">${title}<span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>`;
  },

  // Valor por defecto para input type="date" en zona local (mismo criterio que OrdenTrabajoDetalle; evita desfase UTC con toISOString)
  _fechaHoyParaInputDate() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  },

  // Pestañas estilo Orden de Trabajo: conmuta paneles dentro de #libTabsMount (creación / edición / lectura)
  showLibTab(tab) {
    const mount = document.getElementById('libTabsMount');
    if (!mount) return;
    mount.querySelectorAll('.lib-tab').forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-lib-tab') === tab);
    });
    mount.querySelectorAll('.lib-tab-panel').forEach((panel) => {
      const show = panel.getAttribute('data-lib-panel') === tab;
      panel.style.display = show ? 'block' : 'none';
    });
    // Inicializar SignaturePad cuando la pestaña firmas se hace visible
    if (tab === 'firmas' && !this._firmasInitialized) {
      this._firmasInitialized = true;
      // Esperar a que el browser calcule el layout del panel visible
      requestAnimationFrame(() => {
        setTimeout(() => this.loadSignaturePad(), 150);
      });
    }
  },

  async cargarResponsables() {
    try {
      // Fuente unificada: usuarios activos con persona asociada.
      // El `id` del option = persona.id (compatible con FK a persona).
      const response = await api.get('/usuarios/responsables');
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      const responsables = todos
        .filter(u => u.persona_id)
        .map(u => ({
          id: u.persona_id,
          nombre_completo: u.persona_nombre_completo || u.nombre_completo
        }));

      // Los dos selects usan el mismo catálogo
      this.data.responsablesLinea = responsables;
      this.data.responsablesArea = responsables;
    } catch (error) {
      console.error('Error al cargar responsables:', error);
      this.data.responsablesLinea = [];
      this.data.responsablesArea = [];
    }
  },

  async cargarLiberacion(id) {
    try {
      const response = await produccionService.obtenerLiberacion(id);
      this.data.liberacion = response.data || response;

      // Resetear signaturePads previos para evitar re-subir firmas ya persistidas
      this.signaturePadLinea = null;
      this.signaturePadArea = null;

      if (this.data.liberacion.completado) {
        this.renderLiberacionExistente();
      } else {
        this.activarEdicion();
      }
    } catch (error) {
      toast.error('Error al cargar liberación');
      console.error(error);
      router.navigate('/produccion/liberaciones');
    }
  },

  renderFormularioNuevo() {
    const container = document.getElementById('liberacionContent');

    container.innerHTML = `
      <div style="padding: 1rem;">
        <!-- Mismo bloque de busqueda que Nueva Orden de Trabajo -->
        <div style="border: 1px solid var(--gray-200); padding: 1.25rem; border-radius: 8px; margin-bottom: 1.5rem; background: var(--bg-secondary); box-shadow: 0 1px 3px rgba(0,0,0,0.08);">
          <div style="margin-bottom: 1rem;">
            <h4 style="margin: 0 0 0.25rem; font-size: 0.95rem; font-weight: 600;">Buscar por número de serie</h4>
            <p style="margin: 0; font-size: 0.8rem; color: var(--gray-500);">Ingrese el número de serie del tractor para verificar si puede liberarse y cargar sus datos automáticamente</p>
          </div>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input type="text" id="numSerieVerificar" class="form-input" placeholder="Ej: TE354-2026-0127" style="flex: 1;" />
            <button type="button" class="btn btn-primary" onclick="window.liberacionDetalleView.verificarTractor()">Buscar</button>
          </div>
          <div id="verificacionResult" style="margin-top: 1rem;"></div>
        </div>

        <form id="formLiberacion" novalidate>
        <!-- Formulario principal (oculto hasta verificar) -->
        <div id="formularioPrincipal" style="display: none;">
          <!-- Datos del tractor: siempre visibles, fuera de pestañas (no forman parte de ningún tab) -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            ${this._libSectionTitle('Datos del Tractor')}
            <input type="hidden" name="num_serie" id="numSerie" />
            <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca</label>
                <input type="text" id="marcaTractorInput" class="form-input" readonly style="background: var(--gray-50);" value="" />
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo</label>
                <input type="text" id="modeloTractorInput" class="form-input" readonly style="background: var(--gray-50);" value="" />
              </div>
            </div>
            <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha *</label>
                <input type="date" name="fecha" class="form-input" value="${this._fechaHoyParaInputDate()}" required />
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Horas Motor *</label>
                <input type="number" name="horas_motor" id="horasMotor" class="form-input" step="0.01" min="0" required />
              </div>
            </div>
          </div>

          <!-- Responsables: siempre visibles tras datos del tractor, fuera de pestañas -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            ${this._libSectionTitle('Responsables')}
            <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;">
              <div class="form-group">
                <label class="form-label">Responsable de Línea *</label>
                <select name="responsable_linea_id" id="responsableLinea" class="form-select">
                  <option value="">Seleccione...</option>
                  ${(this.data.responsablesLinea || []).map(r => `
                    <option value="${r.id}" data-nombre="${r.nombre_completo}">
                      ${r.nombre_completo}
                    </option>
                  `).join('')}
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Responsable de Área *</label>
                <select name="responsable_area_id" id="responsableArea" class="form-select">
                  <option value="">Seleccione...</option>
                  ${(this.data.responsablesArea || []).map(r => `
                    <option value="${r.id}" data-nombre="${r.nombre_completo}">
                      ${r.nombre_completo}
                    </option>
                  `).join('')}
                </select>
              </div>
            </div>
          </div>

          <div id="libTabsMount">
            <div class="lib-tabs-bar">
              <button type="button" class="lib-tab active" data-lib-tab="registros" onclick="window.liberacionDetalleView.showLibTab('registros')">Registros</button>
              <button type="button" class="lib-tab" data-lib-tab="partes" onclick="window.liberacionDetalleView.showLibTab('partes')">Partes</button>
              <button type="button" class="lib-tab" data-lib-tab="diseno" onclick="window.liberacionDetalleView.showLibTab('diseno')">Diseño</button>
              <button type="button" class="lib-tab" data-lib-tab="certificacion" onclick="window.liberacionDetalleView.showLibTab('certificacion')">Certificación</button>
            </div>

            <div class="lib-tab-panel" data-lib-panel="registros" style="display: block;">
          <!-- 1. Registros obligatorios al final del ensamble de tractor -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            ${this._libSectionTitle('1. Registros obligatorios al final del ensamble de tractor')}

            <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.1 Registro obligatorio para todo tractor ensamblado</p>
            <div style="display: grid; gap: 0.5rem; margin-bottom: 1rem; padding-left: 0.5rem;">
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="check_list_ensamble" value="true" />
                <span>AMX-PR-FR-02 CHECK LIST DE ENSAMBLE Y FUNCIONAMIENTO <span style="color: var(--danger);">*</span></span>
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="checklist_entrega" value="true" />
                <span>AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR <span style="color: var(--danger);">*</span></span>
              </label>
            </div>

            <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.2 Registro adicional obligatorio para tractor que no cumple con los requisitos técnicos, de funcionamiento y estéticos</p>
            <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="orden_trabajo" value="true" />
                <span>AMX-PR-FR-01 ORDEN DE TRABAJO TRACTOR</span>
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="control_pnc" value="true" />
                <span>AMX-CC-FR-05 CONTROL DE PRODUCTO NO CONFORME</span>
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="remision_almacen" value="true" />
                <span>AMX-VTA-FR-06 REMISION (Solo si se utilizaron refacciones de almacén)</span>
              </label>
            </div>
          </div>
            </div>

            <div class="lib-tab-panel" data-lib-panel="partes" style="display: none;">
          <!-- 2. Partes obligatorias que forman parte del tractor -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            ${this._libSectionTitle('2. Partes obligatorias que forman parte del tractor')}
            <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="sobre_amarillo" value="true" />
                <span>SOBRE AMARILLO CON FORMATOS SEGÚN AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR <span style="color: var(--danger);">*</span></span>
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="caja_herramientas_cafe" value="true" />
                <span>CAJA DE HERRAMIENTAS COMPLETA (CARTON CAFÉ) *</span>
              </label>
              <label id="lblCajaAccesoriosBlanco" style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="caja_accesorios_blanco" value="true" />
                <span class="parte-serie-texto">CAJA DE ACCESORIOS (CORRUGADO BLANCO) (SERIE TD)</span>
                <span class="parte-serie-badge"></span>
              </label>
              <label id="lblCajaHerramientaAzul" style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="caja_herramienta_azul" value="true" />
                <span class="parte-serie-texto">CAJA DE HERRAMIENTA PLÁSTICA AZUL (SERIE TB, TH, TD y TR)</span>
                <span class="parte-serie-badge"></span>
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="checkbox" name="caja_regalos" value="true" />
                <span>CAJA DE REGALOS <span style="color: var(--danger);">*</span></span>
              </label>
            </div>
          </div>
            </div>

            <div class="lib-tab-panel" data-lib-panel="diseno" style="display: none;">
          <!-- 3. Diseño de tractor, características certificadas -->
          <div id="seccionPartesCertificadas" style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem; display: none;">
            ${this._libSectionTitle('3. Diseño de tractor, características certificadas')}
            <div id="partesContainer"></div>
          </div>
          <p id="libDisenoVacíoNueva" style="color: var(--gray-500); font-size: 0.9rem; margin: 0;">Tras verificar el tractor, si aplica modelo, aquí se cargará el listado de partes certificadas.</p>
            </div>

            <div class="lib-tab-panel" data-lib-panel="certificacion" style="display: none;">
          <!-- Solo datos de certificación (responsables van debajo de Datos del tractor) -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <!-- Leyenda "No aplica": se muestra cuando el modelo no lleva certificación OCIMA.
                 Mismo criterio y mismo tratamiento visual que la sección 3 (Diseño). -->
            <div id="certificacionNoAplica" style="display: none;"></div>
            <div class="lib-grid-3col" id="certificacionCampos" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem;">
              <div class="form-group">
                <label class="form-label">Modelo Certificado *</label>
                <input
                  type="text"
                  name="modelo_certificado"
                  id="modeloCertificado"
                  class="form-input"
                  readonly
                  style="background: var(--gray-50); cursor: not-allowed;"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Folio Certificado</label>
                <input
                  type="text"
                  name="folio_certificado"
                  id="folioCertificadoNew"
                  class="form-input"
                  placeholder="Ej: OCIMA-2025-001"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Fecha Certificación</label>
                <input
                  type="date"
                  name="fecha_certificacion"
                  id="fechaCertificacionNew"
                  class="form-input"
                  disabled
                  style="background: var(--gray-50); cursor: not-allowed;"
                />
              </div>
            </div>
          </div>
            </div>
          </div>

          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/produccion/liberaciones')">
              Cancelar
            </button>
            <button type="submit" class="btn btn-success">
              Crear Liberación
            </button>
          </div>
        </div>
        </form>
      </div>
    `;

    const formEl = document.getElementById('formLiberacion');
    formEl.addEventListener('submit', (e) => this.guardarNueva(e));
    // Limpiar mensaje de validación al interactuar con cualquier campo
    formEl.addEventListener('change', (e) => e.target.setCustomValidity(''));
    formEl.addEventListener('input', (e) => e.target.setCustomValidity(''));

    // Fecha certificación se habilita solo cuando hay folio
    const folioNew = document.getElementById('folioCertificadoNew');
    const fechaCertNew = document.getElementById('fechaCertificacionNew');
    if (folioNew && fechaCertNew) {
      folioNew.addEventListener('input', () => {
        if (folioNew.value.trim()) {
          fechaCertNew.disabled = false;
          fechaCertNew.style.background = '';
          fechaCertNew.style.cursor = '';
        } else {
          fechaCertNew.disabled = true;
          fechaCertNew.value = '';
          fechaCertNew.style.background = 'var(--gray-50)';
          fechaCertNew.style.cursor = 'not-allowed';
        }
      });
    }

    // Mismo criterio que OrdenTrabajoDetalle (numSerie): Enter dispara busqueda; si ya habia verificacion OK y el usuario edita el NS, se oculta el formulario y se limpia el area de resultado
    const nsBuscar = document.getElementById('numSerieVerificar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.verificarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.verificacion && this.data.verificacion.puede_liberar) {
          this.data.verificacion = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const vr = document.getElementById('verificacionResult');
          if (vr) vr.innerHTML = '';
        }
      });
    }
  },

  // C-323d: advertencia ámbar de daños abiertos (candado en modo aviso). Sale también cuando otra cosa frena la liberación.
  _advertenciasDanosHtml(verificacion) {
    const advertencias = ((verificacion && verificacion.advertencias) || []).filter(Boolean);
    if (!advertencias.length) return '';
    const escTxt = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return `
      <div class="aviso-danos" role="alert" style="background:#fffbeb;border:1px solid #d97706;border-left:5px solid #d97706;color:#92400e;border-radius:8px;padding:0.8rem 1rem;margin:0.75rem 0;font-size:0.9rem;">
        <div style="font-weight:700;">⚠️ Advertencia: la unidad tiene daños abiertos</div>
        ${advertencias.map(a => `<div style="margin-top:0.3rem;">${escTxt(a)}</div>`).join('')}
        <div style="margin-top:0.4rem;font-size:0.8rem;">Lo correcto es corregirlos en Calidad → Producto No Conforme o que Calidad autorice una concesión.</div>
      </div>`;
  },

  async verificarTractor() {
    const numSerie = document.getElementById('numSerieVerificar').value;
    if (!numSerie) {
      toast.error('Ingrese el número de serie');
      return;
    }

    const resultDiv = document.getElementById('verificacionResult');
    resultDiv.innerHTML = '<p>Verificando...</p>';

    try {
      const response = await produccionService.verificarPuedeLiberarse(numSerie);
      const verificacion = response.data || response;
      this.data.verificacion = verificacion;

      if (verificacion.puede_liberar) {
        // No banner verde: marca, modelo y horas ya aparecen en la seccion Datos del Tractor
        // C-323d: con el candado en modo aviso, los daños abiertos llegan como advertencia (ámbar) y no frenan
        resultDiv.innerHTML = this._advertenciasDanosHtml(verificacion);
        toast.success('Tractor verificado. Puede completar la liberacion.');

        // Mostrar formulario y prellenar datos (marca/modelo visibles como en Nueva OT)
        document.getElementById('formularioPrincipal').style.display = 'block';
        document.getElementById('numSerie').value = numSerie;
        document.getElementById('horasMotor').value = verificacion.tractor?.horas_motor || 0;
        document.getElementById('modeloCertificado').value = verificacion.tractor?.modelo || '';
        const marcaIn = document.getElementById('marcaTractorInput');
        const modeloIn = document.getElementById('modeloTractorInput');
        if (marcaIn) marcaIn.value = verificacion.tractor?.marca || '';
        if (modeloIn) modeloIn.value = verificacion.tractor?.modelo || '';

        // Marcar checkboxes según verificación
        if (verificacion.tiene_checklist_ensamble) {
          document.querySelector('input[name="check_list_ensamble"]').checked = true;
        }

        // Sección 2: partes que solo aplican a ciertas series (SERIE TD, TB/TH/TD/TR)
        this._aplicarPartesPorSerieNueva(verificacion.tractor?.modelo || '');

        // Cargar sección 3: Diseño de tractor
        await this.cargarPartesCertificadas(verificacion.tractor?.modelo || '');
      } else {
        let mensajes = verificacion.mensajes?.join('<br>') || 'El tractor no cumple con los requisitos para liberación';
        resultDiv.innerHTML = `
          <div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">
            <strong>No se puede liberar</strong>
            <p style="margin-top: 0.5rem;">${mensajes}</p>
          </div>
          ${this._advertenciasDanosHtml(verificacion)}
        `;
        document.getElementById('formularioPrincipal').style.display = 'none';
        const marcaIn = document.getElementById('marcaTractorInput');
        const modeloIn = document.getElementById('modeloTractorInput');
        if (marcaIn) marcaIn.value = '';
        if (modeloIn) modeloIn.value = '';
      }
    } catch (error) {
      resultDiv.innerHTML = `
        <div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">
          ${error.message || 'Error al verificar tractor'}
        </div>
      `;
      const marcaIn = document.getElementById('marcaTractorInput');
      const modeloIn = document.getElementById('modeloTractorInput');
      if (marcaIn) marcaIn.value = '';
      if (modeloIn) modeloIn.value = '';
      console.error(error);
    }
  },

  // Sección 2: partes que solo aplican a ciertas series de tractor. La regla ya venía
  // escrita en la etiqueta del formato ("(SERIE TD)", "(SERIE TB, TH, TD y TR)"); aquí
  // se hace efectiva para que no se exijan en modelos que no las llevan.
  PARTES_POR_SERIE: {
    caja_accesorios_blanco: ['TD'],
    caja_herramienta_azul: ['TB', 'TH', 'TD', 'TR']
  },

  // "TD1104 III GEN" → "TD". Null si no se reconoce la serie.
  _serieDeModelo(modelo) {
    const m = (modelo || '').match(/^\s*(TE|TB|TH|TD|TR)\d{3,4}/i);
    return m ? m[1].toUpperCase() : null;
  },

  // Keys de partes que NO aplican al modelo. Si la serie no se reconoce se devuelve
  // vacío a propósito: ante la duda se sigue exigiendo todo, como antes de este cambio.
  _partesNoAplican(modelo) {
    const serie = this._serieDeModelo(modelo);
    if (!serie) return [];
    return Object.keys(this.PARTES_POR_SERIE)
      .filter(key => !this.PARTES_POR_SERIE[key].includes(serie));
  },

  // Aplica la regla de series a las casillas de la sección 2 en el formulario de alta.
  // Las que no aplican quedan tachadas, deshabilitadas y sin marcar, para que no se
  // envíen ni se exijan. Se llama al verificar el tractor (ahí se conoce el modelo).
  _aplicarPartesPorSerieNueva(modelo) {
    const noAplican = this._partesNoAplican(modelo);

    Object.keys(this.PARTES_POR_SERIE).forEach(key => {
      const input = document.querySelector(`input[name="${key}"]`);
      if (!input) return;

      const label = input.closest('label');
      const texto = label?.querySelector('.parte-serie-texto');
      const badge = label?.querySelector('.parte-serie-badge');
      const noAplica = noAplican.includes(key);

      input.disabled = noAplica;
      if (noAplica) input.checked = false;

      if (label) {
        label.style.opacity = noAplica ? '0.55' : '';
        label.style.cursor = noAplica ? 'not-allowed' : 'pointer';
      }
      if (texto) {
        texto.style.textDecoration = noAplica ? 'line-through' : '';
        texto.style.color = noAplica ? 'var(--gray-400)' : '';
      }
      if (badge) {
        badge.textContent = noAplica ? 'No aplica' : '';
        badge.style.cssText = noAplica
          ? 'color:#6c757d;font-weight:700;font-size:0.75rem;white-space:nowrap;'
          : '';
      }
    });
  },

  // Leyenda "No aplica" reutilizable (mismo tratamiento visual que la sección 3 Diseño).
  _libNoAplicaMsg(modelo, detalle) {
    return `
      <div style="text-align: center; padding: 2rem;">
        <span class="badge badge-secondary" style="font-size: 0.9rem; padding: 0.5rem 1.5rem;">No aplica</span>
        <p style="color: var(--text-muted); margin-top: 0.5rem; font-size: 0.85rem;">
          El modelo ${modelo || 'desconocido'} ${detalle}
        </p>
      </div>
    `;
  },

  // Certificación OCIMA sigue EXACTAMENTE el mismo criterio que el diseño de tractor:
  // si el modelo no tiene partes certificadas definidas, tampoco lleva certificación.
  // `modelo_certificado` se conserva en el DOM (oculto) porque es NOT NULL en BD.
  _toggleCertificacionNueva(modelo, aplica) {
    const campos = document.getElementById('certificacionCampos');
    const aviso = document.getElementById('certificacionNoAplica');
    if (!campos || !aviso) return;

    if (aplica) {
      campos.style.display = 'grid';
      aviso.style.display = 'none';
      aviso.innerHTML = '';
      return;
    }

    campos.style.display = 'none';
    aviso.style.display = 'block';
    aviso.innerHTML = this._libNoAplicaMsg(modelo, 'no cuenta con certificación OCIMA');

    // Limpiar por si se capturó algo antes de verificar el tractor.
    const folio = document.getElementById('folioCertificadoNew');
    const fechaCert = document.getElementById('fechaCertificacionNew');
    if (folio) folio.value = '';
    if (fechaCert) {
      fechaCert.value = '';
      fechaCert.disabled = true;
    }
  },

  async cargarPartesCertificadas(modelo) {
    try {
      // Extraer modelo base (ej: "TE354 III GEN" → "TE354")
      const match = modelo.match(/^((?:TE|TB|TH|TD|TR)\d{3,4})/i);
      const baseModelo = match ? match[1] : modelo;

      const response = await produccionService.obtenerPartesModelo(baseModelo);
      const data = response.data || response;

      const vacioMsg = document.getElementById('libDisenoVacíoNueva');
      const sec = document.getElementById('seccionPartesCertificadas');

      if (!data || data.no_aplica || !data.partes || data.partes.length === 0) {
        if (sec) {
          sec.style.display = 'block';
          document.getElementById('partesContainer').innerHTML = `
            <div style="text-align: center; padding: 2rem;">
              <span class="badge badge-secondary" style="font-size: 0.9rem; padding: 0.5rem 1.5rem;">No aplica</span>
              <p style="color: var(--text-muted); margin-top: 0.5rem; font-size: 0.85rem;">
                El modelo ${modelo || 'desconocido'} no tiene partes certificadas definidas
              </p>
            </div>
          `;
        }
        if (vacioMsg) vacioMsg.style.display = 'none';
        this.data.partesTemplate = null;
        this._toggleCertificacionNueva(modelo, false);
        return;
      }

      if (vacioMsg) vacioMsg.style.display = 'none';
      this.data.partesTemplate = data;
      this._toggleCertificacionNueva(modelo, true);

      const container = document.getElementById('partesContainer');
      container.innerHTML = `
        ${data.codigo_diseno ? `
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
            <p style="font-size: 0.9rem; margin: 0;">${data.codigo_diseno}</p>
            <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
              <input type="checkbox" id="checkCodigoDiseno" />
            </label>
          </div>
        ` : ''}

        <div class="table-container">
          <table class="table" style="margin: 0;">
            <thead>
              <tr>
                <th></th>
                <th>Parte</th>
                <th class="tbl-hide-mobile">Código de Parte</th>
                <th class="tbl-hide-mobile" style="width: 60px; text-align: center;">Ok</th>
              </tr>
            </thead>
            <tbody>
              ${data.partes.map((p, i) => `
                <tr>
                  <td><button class="tbl-expand-btn" onclick="window.liberacionDetalleView.toggleParteRow('new-${i}')">&#9654;</button></td>
                  <td>${p.parte}</td>
                  <td class="tbl-hide-mobile">${p.codigo_parte || '<span style="color: var(--text-muted);">—</span>'}</td>
                  <td class="tbl-hide-mobile" style="text-align: center;">
                    <input type="checkbox" class="parte-check" data-index="${i}" />
                  </td>
                </tr>
                <tr class="tbl-detail-row" id="detail-parte-new-${i}">
                  <td colspan="4" class="tbl-detail-cell">
                    <dl class="tbl-detail-grid">
                      <dt>Código</dt><dd>${p.codigo_parte || '—'}</dd>
                      <dt>Ok</dt><dd><input type="checkbox" class="parte-check" data-index="${i}" /></dd>
                    </dl>
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;

      document.getElementById('seccionPartesCertificadas').style.display = 'block';
    } catch (error) {
      console.error('Error al cargar partes certificadas:', error);
    }
  },

  formatFecha(fecha) {
    if (!fecha) return '-';
    const str = typeof fecha === 'string' ? fecha : fecha.toISOString();
    const [y, m, d] = str.substring(0, 10).split('-');
    return `${d}/${m}/${y}`;
  },

  renderLiberacionExistente() {
    const container = document.getElementById('liberacionContent');
    const l = this.data.liberacion;
    const ci = typeof l.checklist_items === 'string' ? JSON.parse(l.checklist_items) : (l.checklist_items || {});
    const reg = ci.registros || {};
    const par = ci.partes || {};
    let pc;
    try {
      pc = typeof l.partes_certificadas === 'string' ? JSON.parse(l.partes_certificadas) : l.partes_certificadas;
    } catch (e) {
      pc = null;
    }

    // Mismo criterio para Diseño y Certificación: si el modelo no tiene partes
    // certificadas definidas, tampoco lleva certificación OCIMA.
    const aplicaCert = !!(pc && pc.partes && pc.partes.length > 0);

    // Sección 2: partes restringidas por serie de tractor.
    const partesNA = this._partesNoAplican(l.tractor_modelo || l.modelo_certificado);

    const htmlDiseno = aplicaCert
      ? `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <h3 style="margin-bottom: 1rem;">3. Diseño de tractor, características certificadas</h3>
        ${pc.codigo_diseno ? `
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
          <p style="font-size: 0.9rem; margin: 0;">${pc.codigo_diseno}</p>
          <span style="color: ${pc.codigo_diseno_verificado ? 'var(--success)' : 'var(--text-muted)'}; font-size: 1.2rem;">
            ${pc.codigo_diseno_verificado ? '✓' : '✗'}
          </span>
        </div>
        ` : ''}
        <div class="table-container">
          <table class="table" style="margin: 0;">
            <thead>
              <tr>
                <th></th>
                <th>Parte</th>
                <th class="tbl-hide-mobile">Código de Parte</th>
                <th class="tbl-hide-mobile" style="width: 60px; text-align: center;">Ok</th>
              </tr>
            </thead>
            <tbody>
              ${pc.partes.map((p, idx) => {
                const okIcon = `<span style="color: ${p.verificado ? 'var(--success)' : 'var(--text-muted)'}; font-size: 1.2rem;">${p.verificado ? '✓' : '✗'}</span>`;
                return `
                <tr>
                  <td><button class="tbl-expand-btn" onclick="window.liberacionDetalleView.toggleParteRow('ro-${idx}')">&#9654;</button></td>
                  <td>${p.parte}</td>
                  <td class="tbl-hide-mobile">${p.codigo_parte || '<span style="color: var(--text-muted);">—</span>'}</td>
                  <td class="tbl-hide-mobile" style="text-align: center;">${okIcon}</td>
                </tr>
                <tr class="tbl-detail-row" id="detail-parte-ro-${idx}">
                  <td colspan="4" class="tbl-detail-cell">
                    <dl class="tbl-detail-grid">
                      <dt>Código</dt><dd>${p.codigo_parte || '—'}</dd>
                      <dt>Ok</dt><dd>${okIcon}</dd>
                    </dl>
                  </td>
                </tr>
              `;
              }).join('')}
            </tbody>
          </table>
        </div>
      </div>`
      : `<div style="text-align: center; padding: 2rem;">
          <span class="badge badge-secondary" style="font-size: 0.9rem; padding: 0.5rem 1.5rem;">No aplica</span>
          <p style="color: var(--text-muted); margin-top: 0.5rem; font-size: 0.85rem;">
            El modelo ${l.tractor_modelo || l.modelo_certificado || 'desconocido'} no tiene partes certificadas definidas
          </p>
        </div>`;

    document.getElementById('cardHeader').innerHTML = `
      <h2 class="card-title">Liberación de Tractor</h2>
      <div style="display: flex; gap: 0.5rem;">
        <button class="btn btn-secondary" onclick="router.navigate('/produccion/liberaciones')">
          &larr; Volver
        </button>
        ${permisos.canPrint('liberaciones') ? `
          <button class="btn btn-primary" onclick="window.liberacionDetalleView.imprimir()">
            🖨️ Imprimir
          </button>
          <button class="btn btn-success" onclick="window.liberacionDetalleView.descargarPDF()">
            📄 Descargar PDF
          </button>
        ` : ''}
      </div>
    `;

    container.innerHTML = `
      <div style="padding: 1rem;">
        <!-- Datos del tractor: mismo formato que creación -->
        <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
          ${this._libSectionTitle('Datos del Tractor')}
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Num. Serie</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.num_serie}" />
            </div>
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.marca || '-'}" />
            </div>
          </div>
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.tractor_modelo || l.modelo_certificado || '-'}" />
            </div>
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${this.formatFecha(l.fecha)}" />
            </div>
          </div>
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Horas Motor</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.horas_motor} hrs" />
            </div>
          </div>
        </div>

        <div id="libTabsMount">
          <div class="lib-tabs-bar">
            <button type="button" class="lib-tab active" data-lib-tab="registros" onclick="window.liberacionDetalleView.showLibTab('registros')">Registros</button>
            <button type="button" class="lib-tab" data-lib-tab="partes" onclick="window.liberacionDetalleView.showLibTab('partes')">Partes</button>
            <button type="button" class="lib-tab" data-lib-tab="diseno" onclick="window.liberacionDetalleView.showLibTab('diseno')">Diseño</button>
            <button type="button" class="lib-tab" data-lib-tab="certificacion" onclick="window.liberacionDetalleView.showLibTab('certificacion')">Certificación</button>
            <button type="button" class="lib-tab" data-lib-tab="firmas" onclick="window.liberacionDetalleView.showLibTab('firmas')">Firmas</button>
          </div>

          <div class="lib-tab-panel" data-lib-panel="registros" style="display: block;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <h3 style="margin-bottom: 1rem;">1. Registros obligatorios al final del ensamble de tractor</h3>
              <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.1 Registro obligatorio para todo tractor ensamblado</p>
              <div style="display: grid; gap: 0.5rem; margin-bottom: 1rem; padding-left: 0.5rem;">
                ${this.renderCheckItem('AMX-PR-FR-02 CHECK LIST DE ENSAMBLE Y FUNCIONAMIENTO', reg.check_list_ensamble)}
                ${this.renderCheckItem('AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR', reg.checklist_entrega)}
              </div>
              <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.2 Registro adicional obligatorio para tractor que no cumple con los requisitos técnicos, de funcionamiento y estéticos</p>
              <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
                ${this.renderCheckItem('AMX-PR-FR-01 ORDEN DE TRABAJO TRACTOR', reg.orden_trabajo)}
                ${this.renderCheckItem('AMX-CC-FR-05 CONTROL DE PRODUCTO NO CONFORME', reg.control_pnc)}
                ${this.renderCheckItem('AMX-VTA-FR-06 REMISION (Solo si se utilizaron refacciones de almacén)', reg.remision_almacen)}
              </div>
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="partes" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <h3 style="margin-bottom: 1rem;">2. Partes obligatorias que forman parte del tractor</h3>
              <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
                ${this.renderCheckItem('SOBRE AMARILLO CON FORMATOS SEGÚN AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR', par.sobre_amarillo)}
                ${this.renderCheckItem('CAJA DE HERRAMIENTAS COMPLETA (CARTON CAFÉ)', par.caja_herramientas_cafe)}
                ${this.renderCheckItem('CAJA DE ACCESORIOS (CORRUGADO BLANCO) (SERIE TD)', par.caja_accesorios_blanco, partesNA.includes('caja_accesorios_blanco'))}
                ${this.renderCheckItem('CAJA DE HERRAMIENTA PLÁSTICA AZUL (SERIE TB, TH, TD y TR)', par.caja_herramienta_azul, partesNA.includes('caja_herramienta_azul'))}
                ${this.renderCheckItem('CAJA DE REGALOS', par.caja_regalos)}
              </div>
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="diseno" style="display: none;">
            ${htmlDiseno}
          </div>

          <div class="lib-tab-panel" data-lib-panel="certificacion" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              ${aplicaCert ? `
              <div class="lib-grid-3col" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem;">
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo Certificado</label>
                  <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.modelo_certificado || '-'}" />
                </div>
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Folio Certificado</label>
                  <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.folio_certificado || '-'}" />
                </div>
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha Certificación</label>
                  <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${this.formatFecha(l.fecha_certificacion)}" />
                </div>
              </div>
              ` : this._libNoAplicaMsg(l.tractor_modelo || l.modelo_certificado, 'no cuenta con certificación OCIMA')}
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="firmas" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <h3 style="margin-bottom: 1rem;">Firmas</h3>
              <div class="lib-firmas-grid">
                <div style="text-align: center;">
                  ${l.responsable_linea_firma_url ? `
                    <img src="${l.responsable_linea_firma_url}" style="max-width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                  ` : ''}
                  <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem;">
                    <strong>${l.responsable_linea}</strong><br>
                    <small style="color: var(--text-muted);">Responsable de línea de producto</small>
                  </div>
                </div>
                <div style="text-align: center;">
                  ${l.responsable_area_firma_url ? `
                    <img src="${l.responsable_area_firma_url}" style="max-width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                  ` : ''}
                  <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem;">
                    <strong>${l.responsable_area}</strong><br>
                    <small style="color: var(--text-muted);">Responsable de área de producción</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    this.showLibTab('registros');
  },

  imprimir() {
    router.navigate(`/produccion/liberaciones/${this.data.liberacion.id}/print`);
  },

  async descargarPDF() {
    const l = this.data.liberacion;
    try {
      toast.info('Generando PDF...');

      // Cargar html2pdf si no está cargado
      if (!window.html2pdf) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      // Importar el generador HTML
      const { default: PrintLiberacion } = await import('./PrintLiberacion.js');
      const html = PrintLiberacion.generateHTML(l);

      // Crear contenedor temporal
      const tempDiv = document.createElement('div');
      tempDiv.style.cssText = 'position:fixed;top:0;left:-9999px;width:210mm;opacity:0;pointer-events:none;';
      tempDiv.innerHTML = html;
      document.body.appendChild(tempDiv);

      // Generar PDF
      await window.html2pdf()
        .set({
          margin: [5, 5, 5, 5],
          filename: `Liberacion_${l.num_serie}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['css', 'legacy'] }
        })
        .from(tempDiv.querySelector('.lp'))
        .save();

      document.body.removeChild(tempDiv);
      toast.success('PDF descargado');
    } catch (error) {
      toast.error('Error al generar PDF');
      console.error(error);
    }
  },

  async completarLiberacion() {
    // Si hay cambios pendientes, exigir guardar primero (patrón Recepciones/OT/Checklist)
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator && indicator.style.display !== 'none') {
      toast.warning('Guarde los cambios antes de completar la liberación');
      return;
    }

    const l = this.data.liberacion;
    const errores = [];

    // 1. Validar Registros (todos deben estar marcados)
    const regIds = ['edit_check_list_ensamble', 'edit_checklist_entrega', 'edit_orden_trabajo', 'edit_control_pnc', 'edit_remision_almacen'];
    if (regIds.some(id => !document.getElementById(id)?.checked)) {
      errores.push({ msg: 'Debe completar todos los registros', tab: 'registros' });
    }

    // 2. Validar Partes: solo las que aplican a la serie del tractor. El corrugado blanco
    //    es exclusivo de la SERIE TD y la caja azul de TB/TH/TD/TR, así que exigirlas en
    //    un TE dejaba la liberación imposible de completar.
    const partesNoAplican = this._partesNoAplican(l.tractor_modelo || l.modelo_certificado);
    const partesPorId = {
      edit_sobre_amarillo: 'sobre_amarillo',
      edit_caja_herramientas_cafe: 'caja_herramientas_cafe',
      edit_caja_accesorios_blanco: 'caja_accesorios_blanco',
      edit_caja_herramienta_azul: 'caja_herramienta_azul',
      edit_caja_regalos: 'caja_regalos'
    };
    const faltaAlgunaParte = Object.keys(partesPorId).some(id =>
      !partesNoAplican.includes(partesPorId[id]) && !document.getElementById(id)?.checked
    );
    if (faltaAlgunaParte) {
      errores.push({ msg: 'Debe completar todas las partes', tab: 'partes' });
    }

    // 3. Validar Diseño (código de diseño + partes certificadas)
    const pc = typeof l.partes_certificadas === 'string' ? JSON.parse(l.partes_certificadas) : (l.partes_certificadas || {});
    if (pc && pc.partes && pc.partes.length > 0) {
      const checkDiseno = document.getElementById('edit_codigo_diseno');
      const faltaDiseno = checkDiseno && !checkDiseno.checked;
      const faltaPartes = pc.partes.some((_, i) => {
        const check = document.querySelector(`.edit-parte-check[data-index="${i}"]`);
        return !check?.checked;
      });
      if (faltaDiseno || faltaPartes) {
        errores.push({ msg: 'Debe completar todo el diseño de tractor', tab: 'diseno' });
      }
    }

    // 4. Validar Firmas (deben estar persistidas como URL desde guardar)
    if (!l.responsable_linea_firma_url) {
      errores.push({ msg: 'Falta firma de responsable de línea', tab: 'firmas' });
    }
    if (!l.responsable_area_firma_url) {
      errores.push({ msg: 'Falta firma de responsable de área', tab: 'firmas' });
    }

    if (errores.length > 0) {
      this.showLibTab(errores[0].tab);
      toast.error(errores[0].msg);
      return;
    }

    modal.confirm(
      'Completar Liberación',
      '¿Está seguro de completar esta liberación? Una vez completada no podrá ser editada.',
      async () => {
        try {
          this._showProgress('Completando liberación...');
          // Firmas ya persistidas con "Guardar cambios"
          const response = await produccionService.completarLiberacion(l.id, {
            responsable_linea_firma_url: l.responsable_linea_firma_url,
            responsable_area_firma_url: l.responsable_area_firma_url
          });

          this.data.liberacion = response.data || response;
          this._hideProgress();
          toast.success('Liberación completada');
          this.renderLiberacionExistente();
        } catch (error) {
          this._hideProgress();
          toast.error(error.message || 'Error al completar liberación');
          console.error(error);
        }
      }
    );
  },

  activarEdicion() {
    const container = document.getElementById('liberacionContent');
    const l = this.data.liberacion;
    const ci = typeof l.checklist_items === 'string' ? JSON.parse(l.checklist_items) : (l.checklist_items || {});
    const reg = ci.registros || {};
    const par = ci.partes || {};
    let pc;
    try {
      pc = typeof l.partes_certificadas === 'string' ? JSON.parse(l.partes_certificadas) : (l.partes_certificadas || {});
    } catch (e) {
      pc = {};
    }

    // Mismo criterio para Diseño y Certificación (ver renderLiberacionExistente).
    const aplicaCertEdicion = !!(pc && pc.partes && pc.partes.length > 0);

    // Sección 2: partes restringidas por serie de tractor.
    const partesNAEdicion = this._partesNoAplican(l.tractor_modelo || l.modelo_certificado);

    const htmlDisenoEdicion = aplicaCertEdicion
      ? `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <h3 style="margin-bottom: 1rem;">3. Diseño de tractor, características certificadas</h3>
        ${pc.codigo_diseno ? `
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
          <p style="font-size: 0.9rem; margin: 0;">${pc.codigo_diseno}</p>
          <input type="checkbox" id="edit_codigo_diseno" ${pc.codigo_diseno_verificado ? 'checked' : ''} />
        </div>
        ` : ''}
        <div class="table-container">
          <table class="table" style="margin: 0;">
            <thead>
              <tr>
                <th></th>
                <th>Parte</th>
                <th class="tbl-hide-mobile">Código de Parte</th>
                <th class="tbl-hide-mobile" style="width: 60px; text-align: center;">Ok</th>
              </tr>
            </thead>
            <tbody>
              ${pc.partes.map((p, i) => `
                <tr>
                  <td><button class="tbl-expand-btn" onclick="window.liberacionDetalleView.toggleParteRow('ed-${i}')">&#9654;</button></td>
                  <td>${p.parte}</td>
                  <td class="tbl-hide-mobile">${p.codigo_parte || '—'}</td>
                  <td class="tbl-hide-mobile" style="text-align: center;">
                    <input type="checkbox" class="edit-parte-check" data-index="${i}" ${p.verificado ? 'checked' : ''} onchange="document.querySelectorAll('.edit-parte-check[data-index=&quot;${i}&quot;]').forEach(c => c.checked = this.checked)" />
                  </td>
                </tr>
                <tr class="tbl-detail-row" id="detail-parte-ed-${i}">
                  <td colspan="4" class="tbl-detail-cell">
                    <dl class="tbl-detail-grid">
                      <dt>Código</dt><dd>${p.codigo_parte || '—'}</dd>
                      <dt>Ok</dt><dd><input type="checkbox" class="edit-parte-check" data-index="${i}" ${p.verificado ? 'checked' : ''} onchange="document.querySelectorAll('.edit-parte-check[data-index=&quot;${i}&quot;]').forEach(c => c.checked = this.checked)" /></dd>
                    </dl>
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      </div>`
      : `<div style="text-align: center; padding: 2rem;">
          <span class="badge badge-secondary" style="font-size: 0.9rem; padding: 0.5rem 1.5rem;">No aplica</span>
          <p style="color: var(--text-muted); margin-top: 0.5rem; font-size: 0.85rem;">
            El modelo ${l.tractor_modelo || l.modelo_certificado || 'desconocido'} no tiene partes certificadas definidas
          </p>
        </div>`;

    container.innerHTML = `
      <div style="padding: 1rem;">
        <!-- Datos del tractor: mismo formato que creación -->
        <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
          ${this._libSectionTitle('Datos del Tractor')}
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Num. Serie</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.num_serie}" />
            </div>
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.marca || '-'}" />
            </div>
          </div>
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo</label>
              <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${l.tractor_modelo || l.modelo_certificado || '-'}" />
            </div>
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha</label>
              <input type="date" id="editFecha" class="form-input" value="${l.fecha ? l.fecha.substring(0, 10) : ''}" />
            </div>
          </div>
          <div class="lib-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Horas Motor</label>
              <input type="number" id="editHorasMotor" class="form-input" step="0.01" min="0" value="${l.horas_motor || 0}" />
            </div>
          </div>
        </div>


        <div id="libTabsMount">
          <div class="lib-tabs-bar">
            <button type="button" class="lib-tab active" data-lib-tab="registros" onclick="window.liberacionDetalleView.showLibTab('registros')">Registros</button>
            <button type="button" class="lib-tab" data-lib-tab="partes" onclick="window.liberacionDetalleView.showLibTab('partes')">Partes</button>
            <button type="button" class="lib-tab" data-lib-tab="diseno" onclick="window.liberacionDetalleView.showLibTab('diseno')">Diseño</button>
            <button type="button" class="lib-tab" data-lib-tab="certificacion" onclick="window.liberacionDetalleView.showLibTab('certificacion')">Certificación</button>
            <button type="button" class="lib-tab" data-lib-tab="firmas" onclick="window.liberacionDetalleView.showLibTab('firmas')">Firmas</button>
          </div>

          <div class="lib-tab-panel" data-lib-panel="registros" style="display: block;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <h3 style="margin-bottom: 1rem;">1. Registros obligatorios al final del ensamble de tractor</h3>
              <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.1 Registro obligatorio para todo tractor ensamblado</p>
              <div style="display: grid; gap: 0.5rem; margin-bottom: 1rem; padding-left: 0.5rem;">
                ${this.renderCheckboxEdit('edit_check_list_ensamble', 'AMX-PR-FR-02 CHECK LIST DE ENSAMBLE Y FUNCIONAMIENTO', reg.check_list_ensamble)}
                ${this.renderCheckboxEdit('edit_checklist_entrega', 'AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR', reg.checklist_entrega)}
              </div>
              <p style="font-weight: bold; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.9rem;">1.2 Registro adicional obligatorio para tractor que no cumple con los requisitos técnicos, de funcionamiento y estéticos</p>
              <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
                ${this.renderCheckboxEdit('edit_orden_trabajo', 'AMX-PR-FR-01 ORDEN DE TRABAJO TRACTOR', reg.orden_trabajo)}
                ${this.renderCheckboxEdit('edit_control_pnc', 'AMX-CC-FR-05 CONTROL DE PRODUCTO NO CONFORME', reg.control_pnc)}
                ${this.renderCheckboxEdit('edit_remision_almacen', 'AMX-VTA-FR-06 REMISION (Solo si se utilizaron refacciones de almacén)', reg.remision_almacen)}
              </div>
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="partes" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <h3 style="margin-bottom: 1rem;">2. Partes obligatorias que forman parte del tractor</h3>
              <div style="display: grid; gap: 0.5rem; padding-left: 0.5rem;">
                ${this.renderCheckboxEdit('edit_sobre_amarillo', 'SOBRE AMARILLO CON FORMATOS SEGÚN AMX-VTA-FR-11 CHECKLIST DE ENTREGA DE TRACTOR', par.sobre_amarillo)}
                ${this.renderCheckboxEdit('edit_caja_herramientas_cafe', 'CAJA DE HERRAMIENTAS COMPLETA (CARTON CAFÉ)', par.caja_herramientas_cafe)}
                ${this.renderCheckboxEdit('edit_caja_accesorios_blanco', 'CAJA DE ACCESORIOS (CORRUGADO BLANCO) (SERIE TD)', par.caja_accesorios_blanco, partesNAEdicion.includes('caja_accesorios_blanco'))}
                ${this.renderCheckboxEdit('edit_caja_herramienta_azul', 'CAJA DE HERRAMIENTA PLÁSTICA AZUL (SERIE TB, TH, TD y TR)', par.caja_herramienta_azul, partesNAEdicion.includes('caja_herramienta_azul'))}
                ${this.renderCheckboxEdit('edit_caja_regalos', 'CAJA DE REGALOS', par.caja_regalos)}
              </div>
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="diseno" style="display: none;">
            ${htmlDisenoEdicion}
          </div>

          <div class="lib-tab-panel" data-lib-panel="certificacion" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              ${aplicaCertEdicion ? `
              <div class="lib-grid-3col" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem;">
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo Certificado</label>
                  <input type="text" id="editModeloCertificado" class="form-input" readonly style="background: var(--gray-50);" value="${l.modelo_certificado || ''}" />
                </div>
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Folio Certificado</label>
                  <input type="text" id="editFolioCertificado" class="form-input" value="${l.folio_certificado || ''}" placeholder="Ej: OCIMA-2025-001" />
                </div>
                <div>
                  <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha Certificación</label>
                  <input type="date" id="editFechaCertificacion" class="form-input" value="${l.fecha_certificacion ? l.fecha_certificacion.substring(0, 10) : ''}" ${!l.folio_certificado ? 'disabled style="background: var(--gray-50); cursor: not-allowed;"' : ''} />
                </div>
              </div>
              ` : this._libNoAplicaMsg(l.tractor_modelo || l.modelo_certificado, 'no cuenta con certificación OCIMA')}
            </div>
          </div>

          <div class="lib-tab-panel" data-lib-panel="firmas" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="lib-grid-2col">
                <div style="border: 1px solid var(--gray-200); border-radius: 8px; overflow: hidden; background: white;">
                  <div style="background: var(--bg-secondary); padding: 0.6rem; text-align: center; border-bottom: 1px solid var(--gray-200);">
                    <span style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); font-weight: 600;">Responsable de Línea de Producto *</span>
                  </div>
                  ${l.responsable_linea_firma_url ? `
                    <div style="padding: 1.5rem; text-align: center;">
                      <img src="${l.responsable_linea_firma_url}" style="width: 100%; max-height: 100px; object-fit: contain;" onerror="this.style.display='none'" />
                    </div>
                    <div style="padding: 0 1rem 0.25rem; text-align: center;">
                      <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.liberacionDetalleView.cambiarFirmaExistente('linea')">Cambiar firma</a>
                    </div>
                  ` : `
                    <div class="firma-box" style="position: relative;">
                      <canvas id="firma-linea" class="firma-canvas-new"></canvas>
                      <span class="firma-placeholder" id="placeholder-linea" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; pointer-events: none; color: var(--gray-400);">
                        <span style="font-size: 0.8rem;">Firme aquí</span>
                      </span>
                    </div>
                    <div style="padding: 0 1rem 0.25rem; text-align: center;">
                      <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.liberacionDetalleView.limpiarFirma('linea')">Limpiar</a>
                    </div>
                  `}
                  <div style="padding: 0.5rem 1rem 0.75rem; border-top: 1px solid var(--gray-200);">
                    <span style="font-size: 0.7rem; color: var(--gray-500); text-transform: uppercase; letter-spacing: 0.5px;">Nombre</span>
                    <p style="margin: 0.15rem 0 0; font-weight: 600; font-size: 0.85rem;">${l.responsable_linea || '-'}</p>
                  </div>
                </div>
                <div style="border: 1px solid var(--gray-200); border-radius: 8px; overflow: hidden; background: white;">
                  <div style="background: var(--bg-secondary); padding: 0.6rem; text-align: center; border-bottom: 1px solid var(--gray-200);">
                    <span style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); font-weight: 600;">Responsable de Área de Producción *</span>
                  </div>
                  ${l.responsable_area_firma_url ? `
                    <div style="padding: 1.5rem; text-align: center;">
                      <img src="${l.responsable_area_firma_url}" style="width: 100%; max-height: 100px; object-fit: contain;" onerror="this.style.display='none'" />
                    </div>
                    <div style="padding: 0 1rem 0.25rem; text-align: center;">
                      <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.liberacionDetalleView.cambiarFirmaExistente('area')">Cambiar firma</a>
                    </div>
                  ` : `
                    <div class="firma-box" style="position: relative;">
                      <canvas id="firma-area" class="firma-canvas-new"></canvas>
                      <span class="firma-placeholder" id="placeholder-area" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; pointer-events: none; color: var(--gray-400);">
                        <span style="font-size: 0.8rem;">Firme aquí</span>
                      </span>
                    </div>
                    <div style="padding: 0 1rem 0.25rem; text-align: center;">
                      <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.liberacionDetalleView.limpiarFirma('area')">Limpiar</a>
                    </div>
                  `}
                  <div style="padding: 0.5rem 1rem 0.75rem; border-top: 1px solid var(--gray-200);">
                    <span style="font-size: 0.7rem; color: var(--gray-500); text-transform: uppercase; letter-spacing: 0.5px;">Nombre</span>
                    <p style="margin: 0.15rem 0 0; font-weight: 600; font-size: 0.85rem;">${l.responsable_area || '-'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <!-- Indicador de cambios sin guardar -->
      <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
        Hay cambios sin guardar
      </div>

      <!-- Botones -->
      <div style="display: flex; gap: 1rem; justify-content: flex-end;">
        <button class="btn btn-secondary" onclick="router.navigate('/produccion/liberaciones')">
          Volver
        </button>
        <button class="btn btn-primary" onclick="window.liberacionDetalleView.guardarEdicion()">
          Guardar Cambios
        </button>
        ${permisos.can('liberaciones', 'cerrar') ? `
          <button class="btn btn-success" onclick="window.liberacionDetalleView.completarLiberacion()">
            Completar Liberación
          </button>
        ` : ''}
      </div>
      </div>
    `;

    this.showLibTab('registros');

    // Detectar cambios sin guardar (delay para ignorar cambios del render inicial)
    setTimeout(() => {
      const editArea = document.getElementById('content');
      if (!editArea) return;
      editArea.querySelectorAll('input, select, textarea').forEach(el => {
        el.addEventListener('change', () => {
          const indicator = document.getElementById('unsavedIndicator');
          if (indicator) indicator.style.display = 'block';
        });
        el.addEventListener('input', () => {
          const indicator = document.getElementById('unsavedIndicator');
          if (indicator) indicator.style.display = 'block';
        });
      });
    }, 500);

    // Fecha certificación se habilita solo cuando hay folio
    const folioEdit = document.getElementById('editFolioCertificado');
    const fechaCertEdit = document.getElementById('editFechaCertificacion');
    if (folioEdit && fechaCertEdit) {
      folioEdit.addEventListener('input', () => {
        if (folioEdit.value.trim()) {
          fechaCertEdit.disabled = false;
          fechaCertEdit.style.background = '';
          fechaCertEdit.style.cursor = '';
        } else {
          fechaCertEdit.disabled = true;
          fechaCertEdit.value = '';
          fechaCertEdit.style.background = 'var(--gray-50)';
          fechaCertEdit.style.cursor = 'not-allowed';
        }
      });
    }

    // Firmas se inicializan al abrir la pestaña (showLibTab → 'firmas')
    this._firmasInitialized = false;
  },

  loadSignaturePad() {
    if (typeof SignaturePad !== 'undefined') {
      this.initFirmas();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
    script.onload = () => this.initFirmas();
    document.head.appendChild(script);
  },

  initFirmas() {
    const canvasLinea = document.getElementById('firma-linea');
    const canvasArea = document.getElementById('firma-area');
    // Salir solo si ningún canvas está disponible (ambas firmas ya persistidas)
    if (!canvasLinea && !canvasArea) return;

    const resizeCanvas = (canvas) => {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      // Usar el ancho del contenedor padre para evitar problemas con CSS width:100%
      const parent = canvas.parentElement;
      const width = parent ? parent.clientWidth : canvas.offsetWidth;
      const height = canvas.offsetHeight || 120;
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      canvas.getContext('2d').scale(ratio, ratio);
    };

    const initPad = (canvas) => {
      resizeCanvas(canvas);
      const pad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)'
      });
      const hidePlaceholder = () => {
        const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
        if (placeholder) placeholder.style.display = 'none';
      };
      canvas.addEventListener('pointerdown', hidePlaceholder);
      canvas.addEventListener('touchstart', hidePlaceholder);

      // Activar "Hay cambios sin guardar" al terminar un trazo
      pad.addEventListener('endStroke', () => this._showUnsaved());

      return pad;
    };

    this.signaturePadLinea = canvasLinea ? initPad(canvasLinea) : null;
    this.signaturePadArea = canvasArea ? initPad(canvasArea) : null;
  },

  cambiarFirmaExistente(tipo) {
    const l = this.data.liberacion;
    if (!l) return;
    if (tipo === 'linea') l.responsable_linea_firma_url = null;
    if (tipo === 'area') l.responsable_area_firma_url = null;
    this._showUnsaved && this._showUnsaved();
    this.renderLiberacionExistente();
    this.showLibTab('firmas');
  },

  _showUnsaved() {
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  toggleParteRow(id) {
    const detailRow = document.getElementById(`detail-parte-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  limpiarFirma(tipo) {
    if (tipo === 'linea' && this.signaturePadLinea) {
      this.signaturePadLinea.clear();
      const ph = document.getElementById('placeholder-linea');
      if (ph) ph.style.display = '';
    }
    if (tipo === 'area' && this.signaturePadArea) {
      this.signaturePadArea.clear();
      const ph = document.getElementById('placeholder-area');
      if (ph) ph.style.display = '';
    }
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  renderCheckboxEdit(id, label, value, noAplica = false) {
    // La parte no corresponde a la serie del tractor: deshabilitada y sin marcar, para
    // que no se envíe ni se exija al completar. El id se conserva porque el gate y el
    // guardado lo consultan con `?.checked` (un checkbox deshabilitado da false).
    if (noAplica) {
      return `
        <label style="display: flex; align-items: center; gap: 0.5rem; cursor: not-allowed; opacity: 0.55;">
          <input type="checkbox" id="${id}" disabled />
          <span style="text-decoration: line-through; color: var(--gray-400);">${label}</span>
          <span style="color: #6c757d; font-weight: 700; font-size: 0.75rem; white-space: nowrap;">No aplica</span>
        </label>
      `;
    }
    return `
      <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
        <input type="checkbox" id="${id}" ${value ? 'checked' : ''} />
        <span>${label}</span>
      </label>
    `;
  },

  async guardarEdicion() {
    const l = this.data.liberacion;
    const pc = typeof l.partes_certificadas === 'string' ? JSON.parse(l.partes_certificadas) : (l.partes_certificadas || {});

    const checklist_items = {
      registros: {
        check_list_ensamble: document.getElementById('edit_check_list_ensamble')?.checked || false,
        checklist_entrega: document.getElementById('edit_checklist_entrega')?.checked || false,
        orden_trabajo: document.getElementById('edit_orden_trabajo')?.checked || null,
        control_pnc: document.getElementById('edit_control_pnc')?.checked || null,
        remision_almacen: document.getElementById('edit_remision_almacen')?.checked || null
      },
      partes: {
        sobre_amarillo: document.getElementById('edit_sobre_amarillo')?.checked || false,
        caja_herramientas_cafe: document.getElementById('edit_caja_herramientas_cafe')?.checked || false,
        caja_accesorios_blanco: document.getElementById('edit_caja_accesorios_blanco')?.checked || null,
        caja_herramienta_azul: document.getElementById('edit_caja_herramienta_azul')?.checked || null,
        caja_regalos: document.getElementById('edit_caja_regalos')?.checked || false
      }
    };

    // Partes certificadas (sección 3)
    let partes_certificadas = null;
    if (pc && pc.partes && pc.partes.length > 0) {
      const checkDiseno = document.getElementById('edit_codigo_diseno');
      partes_certificadas = {
        nombre_modelo: pc.nombre_modelo,
        codigo_diseno: pc.codigo_diseno || '',
        codigo_diseno_verificado: checkDiseno?.checked || false,
        partes: pc.partes.map((p, i) => {
          const check = document.querySelector(`.edit-parte-check[data-index="${i}"]`);
          return {
            parte: p.parte,
            codigo_parte: p.codigo_parte,
            verificado: check?.checked || false
          };
        })
      };
    }

    const folioVal = document.getElementById('editFolioCertificado')?.value || '';
    const fechaCertVal = document.getElementById('editFechaCertificacion')?.value || '';

    if (folioVal && !fechaCertVal) {
      toast.error('Si hay folio certificado, la fecha de certificación es obligatoria');
      this.showLibTab('certificacion');
      return;
    }

    try {
      this._showProgress('Preparando datos...');

      // Subir firmas dibujadas (si hay) al bucket unificado liberacion/{num_serie}/firmas/
      let firmaLineaUrl = l.responsable_linea_firma_url || null;
      let firmaAreaUrl = l.responsable_area_firma_url || null;

      // Solo subir firma si el pad tiene trazo Y aún no hay URL persistida.
      // Después del save, cargarLiberacion() resetea los pads y re-renderiza,
      // mostrando img en lugar de canvas para las firmas ya guardadas.
      if (this.signaturePadLinea && !this.signaturePadLinea.isEmpty() && !firmaLineaUrl) {
        this._showProgress('Subiendo firma de línea...');
        firmaLineaUrl = await recepcionService.subirFirma(
          await this.toBlob(this.signaturePadLinea),
          `LIB-${l.id}_firma_linea.png`,
          l.num_serie,
          'liberacion'
        );
      }
      if (this.signaturePadArea && !this.signaturePadArea.isEmpty() && !firmaAreaUrl) {
        this._showProgress('Subiendo firma de área...');
        firmaAreaUrl = await recepcionService.subirFirma(
          await this.toBlob(this.signaturePadArea),
          `LIB-${l.id}_firma_area.png`,
          l.num_serie,
          'liberacion'
        );
      }

      const data = {
        fecha: document.getElementById('editFecha')?.value || undefined,
        horas_motor: parseFloat(document.getElementById('editHorasMotor')?.value) || undefined,
        checklist_items,
        partes_certificadas,
        folio_certificado: folioVal || undefined,
        fecha_certificacion: fechaCertVal || undefined,
        responsable_linea_firma_url: firmaLineaUrl,
        responsable_area_firma_url: firmaAreaUrl
      };

      this._showProgress('Guardando cambios...');
      await produccionService.actualizarLiberacion(l.id, data);
      this._hideProgress();
      toast.success('Liberación actualizada');
      const indicator = document.getElementById('unsavedIndicator');
      if (indicator) indicator.style.display = 'none';

      // Recargar para reset de pads + re-render con URLs actualizadas (mismo patrón que OT).
      // Esto evita re-subida de firmas en saves consecutivos.
      await this.cargarLiberacion(l.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al actualizar');
      console.error(error);
    }
  },

  renderCheckItem(label, value, noAplica = false) {
    // La parte no corresponde a la serie del tractor: tachada y marcada "No aplica".
    if (noAplica) {
      return `
        <div style="display: flex; align-items: center; gap: 0.5rem; opacity: 0.55;">
          <span style="color: var(--text-muted); font-size: 1.2rem;">—</span>
          <span style="text-decoration: line-through; color: var(--gray-400);">${label}</span>
          <span style="color: #6c757d; font-weight: 700; font-size: 0.75rem; white-space: nowrap;">No aplica</span>
        </div>
      `;
    }
    if (value === null || value === undefined) {
      return `
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span style="color: var(--text-muted); font-size: 1.2rem;">—</span>
          <span style="color: var(--text-muted);">${label}</span>
        </div>
      `;
    }
    return `
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <span style="color: ${value ? 'var(--success)' : 'var(--danger)'}; font-size: 1.2rem;">
          ${value ? '✓' : '✗'}
        </span>
        <span>${label}</span>
      </div>
    `;
  },

  async guardarNueva(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    // Obtener responsables de los selects
    const lineaSelect = document.getElementById('responsableLinea');
    const areaSelect = document.getElementById('responsableArea');

    const responsableLineaId = lineaSelect?.value;
    const responsableLineaNombre = lineaSelect?.options[lineaSelect.selectedIndex]?.text || '';
    const responsableAreaId = areaSelect?.value;
    const responsableAreaNombre = areaSelect?.options[areaSelect.selectedIndex]?.text || '';

    const checklist_items = {
      registros: {
        check_list_ensamble: formData.get('check_list_ensamble') === 'true',
        checklist_entrega: formData.get('checklist_entrega') === 'true',
        orden_trabajo: formData.get('orden_trabajo') === 'true' || null,
        control_pnc: formData.get('control_pnc') === 'true' || null,
        remision_almacen: formData.get('remision_almacen') === 'true' || null
      },
      partes: {
        sobre_amarillo: formData.get('sobre_amarillo') === 'true',
        caja_herramientas_cafe: formData.get('caja_herramientas_cafe') === 'true',
        caja_accesorios_blanco: formData.get('caja_accesorios_blanco') === 'true' || null,
        caja_herramienta_azul: formData.get('caja_herramienta_azul') === 'true' || null,
        caja_regalos: formData.get('caja_regalos') === 'true'
      }
    };

    // Recopilar partes certificadas (sección 3)
    let partes_certificadas = null;
    if (this.data.partesTemplate) {
      const checks = document.querySelectorAll('.parte-check');
      const checkDiseno = document.getElementById('checkCodigoDiseno');
      const partes = this.data.partesTemplate.partes.map((p, i) => ({
        parte: p.parte,
        codigo_parte: p.codigo_parte,
        verificado: checks[i]?.checked || false
      }));
      partes_certificadas = {
        nombre_modelo: this.data.partesTemplate.nombre_modelo,
        codigo_diseno: this.data.partesTemplate.codigo_diseno || '',
        codigo_diseno_verificado: checkDiseno?.checked || false,
        partes
      };
    }

    const data = {
      num_serie: formData.get('num_serie'),
      fecha: formData.get('fecha'),
      horas_motor: parseFloat(formData.get('horas_motor')),
      checklist_items,
      partes_certificadas,
      modelo_certificado: formData.get('modelo_certificado'),
      folio_certificado: formData.get('folio_certificado'),
      fecha_certificacion: formData.get('fecha_certificacion'),
      responsable_linea: responsableLineaNombre !== 'Seleccione...' ? responsableLineaNombre : '',
      responsable_linea_id: parseInt(responsableLineaId, 10),
      responsable_area: responsableAreaNombre !== 'Seleccione...' ? responsableAreaNombre : '',
      responsable_area_id: parseInt(responsableAreaId, 10)
    };

    // Validar obligatorios
    const validaciones = [
      { el: form.querySelector('[name="fecha"]'), ok: formData.get('fecha'), msg: 'La fecha es requerida' },
      { el: form.querySelector('[name="horas_motor"]'), ok: formData.get('horas_motor'), msg: 'Las horas de motor son requeridas' },
      { el: document.getElementById('responsableLinea'), ok: responsableLineaId, msg: 'Debe seleccionar responsable de línea' },
      { el: document.getElementById('responsableArea'), ok: responsableAreaId, msg: 'Debe seleccionar responsable de área' },
    ];

    // Limpiar validaciones previas
    validaciones.forEach(v => v.el?.setCustomValidity(''));

    const invalido = validaciones.find(v => !v.ok);
    if (invalido) {
      invalido.el.setCustomValidity(invalido.msg);
      invalido.el.reportValidity();
      return;
    }

    try {
      this._showProgress('Creando liberación...');
      const response = await produccionService.crearLiberacion(data);
      this._hideProgress();
      toast.success('Liberación creada exitosamente');
      const liberacion = response.data || response;
      router.navigate(`/produccion/liberaciones/${liberacion.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear liberación');
      console.error(error);
    }
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  }
};
